var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('dialogComp',{attrs:{"width":"640px","title":"开箱不良明细","isShow":_vm.isShow,"isShowFooter":false},on:{"close":_vm.close}},[_c('tableComp',{attrs:{"data":_vm.tableData,"col-configs":_vm.theadName}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }